<template>
  <div class="flex justify-center px-4 py-2 md:p-0">
    <router-link
      :to="$i18nRoute({ name: 'NewsroomRegister' })"
      class="inline-block rounded-full bg-white px-4 py-2 text-sm font-semibold text-ink transition-colors hover:bg-white/90"
    >
      {{ $t('components.top_nav.free_newsroom') }}
    </router-link>
  </div>
</template>

<script>
/**
 * @module FreeNewsroomButton
 */
export default {
  name: 'FreeNewsroomButton'
}
</script>
